import React from 'react';
import { PRICE, PRICE_BEFORE } from '../data/piano';

/**
 * Honest announcement bar: no fake timers or counters.
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="307v5ml4e0myz">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-57" data-mp="2vcz5syswsvbb">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-58" data-mp="2mewvfsnacqbd">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-59" data-mp="2hfahti3jp821" />
        </span>
        <span className="text-stone-50/80" data-id="element-60" data-mp="2hhn5mbvzicn0">
          <span className="hidden sm:inline" data-id="element-61" data-mp="2ch8x6sqh10og">Introductory price: </span>
          <span className="sm:hidden" data-id="element-62" data-mp="28evxakyenwzl">Now: </span>
        </span>
        <span className="font-semibold text-stone-50" data-id="element-63" data-mp="28gp3y090qh7l">{PRICE}</span>
        <s className="text-stone-50/50" data-id="element-64" data-mp="anjhcah5xiou">{PRICE_BEFORE}</s>
        <span className="hidden text-stone-50/80 sm:inline" data-id="element-65" data-mp="6niqfqcvnf0w">· One-time payment · 7-day money-back guarantee</span>
      </div>
    </div>;
}